import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/History_of_Sci_&_Tech_-_Artificial_Intelligence_&_Robotics.png';

function HistoryPageAIAndRoboticsGo() {
  return (
    <QuizPage
      title="History: Artificial Intelligence & Robotics"
      subTopic="Artificial Intelligence & Robotics"
      backgroundImage={historyImage}
      returnPath="/History-AI-Robotics"
    />
  );
}

export default HistoryPageAIAndRoboticsGo;
